import Icon from '../../../atoms/icon'
import React from 'react'
import Button from '../../../atoms/button'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { FsCore } from '../../../types/fs-core'

const cashplusApplicationSentMessage = {
  title: 'We’ve sent your application to Zempler bank',
  body: 'Zempler Bank will advise you of the outcome of your application via email within 1 working day –please ensure that you monitor your email inbox, including your Junk Inbox for this.<br/>  <br/>For questions about your account application, please contact Zempler directly on 0330 024 0924',
}

const cashPlusInfo = {
  copy: {
    Approved: {
      title: 'We’re pleased to confirm that Zempler Bank have approved your application.',
      body: `<div>You will also receive these details in an email from Zempler Bank within 1 working day – please ensure that you monitor your email inbox, including your Junk Inbox for this. <br/>  <br/> You will also receive your card in the post within 3-5 working days at your home address. To activate the account, you simply need to ensure that you pay funds into the bank account within 60 days of your application.<br/>  <br/>For questions about your account application, please contact Zempler directly on 0330 024 0924</div>`,
    },
    InternalReview: cashplusApplicationSentMessage,
    DocsRequired: cashplusApplicationSentMessage,
    Duplicate: {
      title: 'It looks like there is already an existing application with Zempler bank',
      body: '<div>If you have any questions about the status of your application, please contact Zempler Bank directly.</div>',
    },
    Error: {
      title: "Hmm, something's not right.",
      body: "<div>Let's try that again. Please re-submit the form and we'll pick up where we left off</div>",
    },
  },
}

const ResultsCard = ({ application }) => {
  return (
    <div className='ResultsCard'>
      <div className='ResultsCard__title'>
        {application.status === 'Approved' && (
          <Icon glyph='tick-circle-bg' size={48} desktopSize={64} fill='#924a8b' />
        )}
        <h2>{cashPlusInfo.copy[application.status]?.title}</h2>
      </div>

      <div className='ResultsCard__details'>
        {application.status !== 'Error' && (
          <div className='ResultsCard__details__success'>
            {application.referenceNumber && (
              <div>
                <strong>Application Reference</strong>: {application.referenceNumber}
              </div>
            )}
            {application.sortCode && (
              <div>
                <strong>Sort Code</strong>: {application.sortCode}
              </div>
            )}
            {application.accountNumber && (
              <div>
                <strong>Account Number</strong>: {application.accountNumber}
              </div>
            )}
            {application.deliveryAddress_AddressLine && (
              <div>
                <strong>Delivery Address</strong>: {application.deliveryAddress_AddressLine}
              </div>
            )}
            {application.deliveryAddress_Postcode && (
              <div>
                <strong>Delivery Post Code</strong>: {application.deliveryAddress_Postcode}
              </div>
            )}
            {application.deliveryAddress_TownOrCity && (
              <div>
                <strong>Delivery City</strong>: {application.deliveryAddress_TownOrCity}
              </div>
            )}
          </div>
        )}
        <div
          className={classNames('ResultsCard__details__body', {
            'ResultsCard__details__body--fullwidth': application.status === 'Error',
          })}
          dangerouslySetInnerHTML={{ __html: cashPlusInfo.copy[application.status]?.body }}
        />
      </div>
      {application.status !== 'Error' ? (
        <div className='ResultsCard__details__callout'>
          This service is provided by Advanced Payment Solutions Limited (APS), trading as Zempler
          Bank. Registered in England and Wales at Cottons Centre, Cottons Lane, London SE1 2QG
          (No.04947027). APS is authorised by the Prudential Regulation Authority and regulated by
          the Financial Conduct Authority and the Prudential Regulation Authority under Firm
          Reference Number 671140.
        </div>
      ) : (
        <div className='ResultsCard__details__backButton'>
          <Button
            variant='primary'
            size='sm'
            onClick={() => {
              history.back()
            }}
          >
            Go Back
          </Button>
        </div>
      )}
    </div>
  )
}

export default connect((state: FsCore.State, props: any) => {
  return {
    ...props,
    application: state.components.smeProviderApplication,
  }
})(ResultsCard)
